import { Component, isDevMode, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CustomLoginFormService } from '@services/custom-login-form.service';
import { GamService } from '@services/gam.service';
import { StorefrontComponent } from '@spartacus/storefront';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [StorefrontComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class App {
  title = isDevMode() ? 'DEV AndesMotor' : 'AndesMotor';
  private subscription: Subscription;

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit(){
    setTimeout(() => {
      this.titleService.setTitle("Andesmotor")
    }, 1300);
  }

  constructor(
    private route: ActivatedRoute,
    private gamService: GamService,
    private loginService: CustomLoginFormService,
    private titleService: Title
  ) {
    this.subscription = this.route.queryParams.subscribe((params) => {
      if (params['token']) {
        const token = params['token'];
        this.gamService.login(token).subscribe(({ rut, password }) => {
          this.loginService.loginWithCredentials(rut, password).subscribe();
        });
      }
    });
  }
}
